"use client";

import { ContactUsForm } from '../components/ContactUs/ContactUsForm';

export default function Contact() {
  return <div className='flex justify-center items-center lg:px-6'>
    <ContactUsForm></ContactUsForm>
  </div>
}
